export default __webpack_public_path__ + "static/media/sector-storage.29143661.png";